module.exports = __webpack_public_path__ + "static/img/sh30s.005c415.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/sh30s.png
// module id = Qi7+
// module chunks = 37